export var DownloadFileType;
(function (DownloadFileType) {
    DownloadFileType["CSV"] = "csv";
    DownloadFileType["IMAGE"] = "image";
    DownloadFileType["JSONL"] = "jsonl";
    DownloadFileType["S3_JSONL"] = "s3_jsonl";
    DownloadFileType["XLSX"] = "xlsx";
})(DownloadFileType || (DownloadFileType = {}));
//# sourceMappingURL=downloadFile.js.map